import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
// import Typography from '@material-ui/core/Typography';
// import RemoveIcon from '@material-ui/icons/Remove';
// import CheckIcon from '@material-ui/icons/Check';

import './ValueSetDialogData.css';

const useStyles = makeStyles({
	root: {
		width: '100%',
		height: '100%',
	},
});

function displayString(x) {
	if (x !== undefined) {
		return x;
	} else {
		return <span className="nullItem">null</span>;
	}
}

function displayBoolean(x) {
	if (x !== undefined) {
		if (x) {
			return 'true';
		} else {
			return 'false';
		}
	} else {
		return <span className="nullItem">null</span>;
	}
}

function displayProperty(title, rawValue) {
	var value = '';

	switch (typeof rawValue) {
		case 'string':
			value = displayString(rawValue);
			break;
		case 'boolean':
			value = displayBoolean(rawValue);
			break;
		case 'number':
			value = displayString(rawValue);
			break;
		case 'undefined':
			value = displayString(rawValue);
			break;
		default:
			console.log(typeof rawValue);
			value = 'XXX';
	}

	return (
		<div className="vsDialogData__itemContainer">
			<div className="vsDialogData__itemLabel">{title}</div>
			<div className="vsDialogData__itemValue">{value}</div>
		</div>
	);
}

function displayContactName(name) {
	if (name !== null && name !== undefined) {
		return <div className="vsDialogData__itemContainer">
			<div className="vsDialogData__itemLabel Underlined">name</div>
			<div className="vsDialogData__itemValue Underlined">{name}</div>
		</div>
	} else {
		return <div className="vsDialogData__itemContainer">
			<div className="vsDialogData__itemLabel Underlined">name</div>
			<div className="vsDialogData__itemValue Underlined"><span className="nullItem">null</span></div>
		</div>
	}
}

function displayContactDetail(telecom) {
	if (telecom !== null && telecom !== undefined) {
		return telecom.map((x, index) => (
			<div className="vsDialogData__itemContainer" key={index}>
				<div className="vsDialogData__itemLabel ">{displayNullCheck(x.system)}</div>
				<div className="vsDialogData__itemValue">{displayNullCheck(x.value)}</div>
			</div>
		));
	}
}

function displayNullCheck(value) {
	if (value !== null && value !== undefined) {
		return value
	} else {
		return <span className="nullItem">null</span>
	};
}

function displayContacts(contact) {
	if (contact !== undefined) {
		return contact.map((x, index) => (
			// <React.Fragment key={index}>
			<div key={index}>
				{displayContactName(x.name)}
				{displayContactDetail(x.telecom)}
			</div>
			// </React.Fragment>
		));


	} else {
		return <div className="vsDialogData__itemContainer">
			<span className="nullItem">null</span>
		</div>

	}
}

export default function ValueSetDialogData(props) {
	const classes = useStyles();

	useEffect(() => {
		if (props) {
			// console.log('props', props);
		}
	});

	return (
		<Paper className={classes.root}>
			<div className="vsDialogData">
				<div className="vsDialogData__left">
					{displayProperty('url', props.url)}
					{displayProperty('version', props.version)}
					{displayProperty('status', props.status)}
					{displayProperty('name', props.name)}
					{displayProperty('title', props.title)}
					{displayProperty('experimental', props.experimental)}
					{displayProperty('date', props.date)}
					{displayProperty('publisher', props.publisher)}
					{displayProperty('description', props.description)}
					{/* // useContext */}
					{displayProperty('jurisdiction', props.jurisdiction)}
					{displayProperty('immutable', props.immutable)}
					{displayProperty('purpose', props.purpose)}
					{displayProperty('copyright', props.copyright)}


				</div>
				<div className="vsDialogData__right">
					<div className="vsDialogData__itemContainer">
						<div className="vsDialogData__itemTitle">Contacts</div>

					</div>
					{displayContacts(props.contact)}
					{/* <div className="vsDialogData__itemContainer">
						<div className="vsDialogData__itemTitle">Properties</div>
					</div>

					<div className="vsDialogData__itemContainer">
						<div className="vsDialogData__itemTitle">Designations</div>
					</div> */}
				</div>
			</div>
		</Paper>
	);
}
